/* ==========================================================================
   Mother Limit — /cart page quantity enforcer
   Prevents The Mother FREE PROMOTION from being set above qty 1
   on the /cart page HTML form (which bypasses the fetch interceptor
   in cart-drawer.js).

   Loaded sitewide via theme.liquid but bails out immediately on
   any page other than /cart.
   ========================================================================== */
(function () {
  if (!window.location.pathname.startsWith('/cart')) return;

  var RESTRICTED_VARIANTS = ['52589380239723', '52621976895851'];
  var MAX_QTY = 1;
  var MSG = 'This promotional item is limited to 1 per order.';
  var lastAlertAt = 0;

  function alertOnce() {
    var now = Date.now();
    if (now - lastAlertAt < 1500) return;
    lastAlertAt = now;
    setTimeout(function () { alert(MSG); }, 0);
  }

  function isRestricted(variantId) {
    return RESTRICTED_VARIANTS.indexOf(String(variantId)) !== -1;
  }

  function getVariantIdFromRow(row) {
    // 1) data attribute
    if (row.dataset && row.dataset.variantId) return row.dataset.variantId;
    // 2) nested element with data-variant-id
    var el = row.querySelector('[data-variant-id]');
    if (el) return el.dataset.variantId;
    // 3) hidden input[name="id"]
    var hidden = row.querySelector('input[name="id"]');
    if (hidden) return hidden.value;
    // 4) product link href ?variant=XXXXX (Origin theme cart page)
    var link = row.querySelector('a[href*="variant="]');
    if (link) {
      var m = link.href.match(/[?&]variant=(\d+)/);
      if (m) return m[1];
    }
    return null;
  }

  function clampFormInputs(form) {
    var clamped = false;
    var inputs = form.querySelectorAll('input[name^="updates"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var row = input.closest('[data-variant-id], .cart-item, tr');
      if (!row) continue;
      var variantId = getVariantIdFromRow(row);
      if (!variantId || !isRestricted(variantId)) continue;
      var desired = parseInt(input.value, 10);
      if (isNaN(desired) || desired <= MAX_QTY) continue;
      input.value = MAX_QTY;
      clamped = true;
    }
    return clamped;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 1) Form submit interceptor (Update cart button)
    var form = document.querySelector('form[action="/cart"]');
    if (form) {
      form.addEventListener('submit', function () {
        if (clampFormInputs(form)) alertOnce();
      });
    }

    // 2) Quantity +/- button interceptor — clamp on blur/change before submit
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.tagName !== 'INPUT') return;
      if (!input.name || input.name.indexOf('updates') !== 0) return;
      var row = input.closest('[data-variant-id], .cart-item, tr');
      if (!row) return;
      var variantId = getVariantIdFromRow(row);
      if (!variantId || !isRestricted(variantId)) return;
      var desired = parseInt(input.value, 10);
      if (isNaN(desired) || desired <= MAX_QTY) return;
      input.value = MAX_QTY;
      alertOnce();
    });
  });
})();
